import { useFormContext } from 'react-hook-form';
import { TOwnershipStructure } from '../types';
import { useMemo } from 'react';

export const useGetOwnerIndex = (linkIndex: number) => {
  const { getValues } = useFormContext<TOwnershipStructure>();
  const ownerIndex = useMemo(() => {
    const ownerId = getValues(`link.${linkIndex}.fromNodeId`);
    const owners = getValues('owners');
    return owners.findIndex((owner) => owner.id === ownerId);
  }, [linkIndex]);
  return { ownerIndex };
};
